import { render, staticRenderFns } from "./RtiIncidentDetails.vue?vue&type=template&id=65addf70&"
import script from "./RtiIncidentDetails.vue?vue&type=script&lang=js&"
export * from "./RtiIncidentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports